import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './complaint.routes';
import addHtml from './modal/show.html';

export class SurveyController {
    $http;
    socket;
    awesomeThings = [];
    surveys = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;


        $scope.$on('$destroy', function () {
            socket.unsyncUpdates('survey');
        });
    }

    $onInit() {

        if (this.$cookies.get('token')) {
            this.$http.get('/api/utils/complaint', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                }
            })
                .then(response => {
                    if (response.data.data) {
                        this.surveys = response.data.data;
                        this.surveys.forEach(s => s.complaint_key = key_to_text(s.complaint_key));
                        this.totalCount = this.surveys.length;
                    }
                });
        } else {
            this.$location.path('main');
        }

        function key_to_text(key) {
            switch (key) {
                case 1:
                    return '信息流评论';
                case 2:
                    return '社区故事';
                case 3:
                    return '社区评论';
                case 4:
                    return '圣经文本评论';
            }
        }
    }

    checkTarget(complaint) {
        this.$http.get(`/api/utils/complaint/${complaint._id}`, {
            header: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'token': this.$cookies.get('token')
            }
        }).then(res => {
            const data = res.data.data;
            this.$uibModal.open({
                template: addHtml,
                size: 'lg',
                /*@ngInject*/
                controller($scope, $http, $uibModalInstance) {
                    $scope.data = data;
                    $scope.cancel = function () {
                        $uibModalInstance.close();
                    };
                }
            });
        });
    }

}

export default angular.module('tttApp.complaint', [uiRouter])
    .config(routing)
    .component('complaint', {
        template: require('./complaint.html'),
        controller: SurveyController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/complaint/complaint.component.js